<template>
    <v-tab-item :value="$route.path" class="pa-3">
        <v-toolbar flat height="90">
            <v-btn
                :disabled="!getPermission('products.tags.create')"
                color="secondary"
                class="text-capitalize px-5"
                depressed
                @click="open(1, {})"
                >{{ translations.addProductTag[lang] }}</v-btn
            >

            <v-spacer></v-spacer>

            <v-col cols="4" class="pa-0">
                <b-search-field></b-search-field>
            </v-col>
        </v-toolbar>

        <v-data-table
            :headers="headers"
            :items="productsTags"
            :footer-props="{
                itemsPerPageOptions: [12],
                showCurrentPage: true,
                pageText: `${page * 12 - 11}-${
                    page * 12 <= serverItemsLength
                        ? page * 12
                        : serverItemsLength
                } ${translations.paginationText[lang]} ${serverItemsLength}`,
            }"
            :page.sync="page"
            :loading="loading"
            :server-items-length="serverItemsLength"
            disable-sort
            class="b-outlined"
        >
            <template v-slot:item.actions="{ item }">
                <v-tooltip color="secondary" top>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            :disabled="!getPermission('products.tags.update')"
                            color="yellow darken-3"
                            icon
                            v-on="on"
                            @click="open(2, item)"
                        >
                            <v-icon v-text="icons.mdiPencilOutline"></v-icon>
                        </v-btn>
                    </template>

                    <span class="font-weight-bold">Update</span>
                </v-tooltip>

                <v-tooltip color="secondary" top>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            :disabled="!getPermission('products.tags.delete')"
                            color="red"
                            icon
                            v-on="on"
                            @click="
                                () => {
                                    productTag = item;
                                    deleteDialog = true;
                                }
                            "
                        >
                            <v-icon v-text="icons.mdiClose"></v-icon>
                        </v-btn>
                    </template>

                    <span class="font-weight-bold">Delete</span>
                </v-tooltip>
            </template>
        </v-data-table>

        <v-dialog v-model="dialog" max-width="400">
            <ProductTagForm :mode="mode" @cancel="dialog = false" />
        </v-dialog>

        <v-dialog v-model="deleteDialog" max-width="500">
            <b-card
                type="delete"
                title="Delete Product Tag"
                :submit-text="{ el: '', en: 'delete', it: '' }"
                :loading="loading"
                :error-message="errorMessage"
                @cancel="deleteDialog = false"
                @submit="remove"
            >
                <div class="subtitle-1 font-weight-medium py-3 px-2">
                    Are you sure you want to delete
                    <span class="font-weight-bold text--primary">{{
                        productTag.name
                    }}</span
                    >?
                </div>
            </b-card>
        </v-dialog>
    </v-tab-item>
</template>

<script>
import { mdiPencilOutline, mdiClose } from "@mdi/js";
import { mapState, mapMutations, mapActions } from "vuex";
import translations from "@/utils/translations/loyaltyPanel/products/productsTab";

import ProductTagForm from "@/components/loyaltyPanel/products/ProductTagForm.vue";

export default {
    name: "ProductsTags",

    mixins: [translations],

    components: { ProductTagForm },

    data() {
        return {
            icons: { mdiPencilOutline, mdiClose },
            page: +this.$route.query.page,
            mode: 0,
        };
    },

    computed: {
        ...mapState(["loading", "errorMessage", "serverItemsLength"]),
        ...mapState("loyaltyPanel/productsTags", ["productsTags"]),

        lang() {
            return this.$route.params.lang;
        },

        headers() {
            return [
                {
                    text: this.translations.name[this.lang],
                    value: "name",
                    width: "33%",
                },
                {
                    text: this.translations.code[this.lang],
                    value: "code",
                    width: "33%",
                },
                {
                    text: this.translations.actions[this.lang],
                    value: "actions",
                    width: "34%",
                },
            ];
        },

        dialog: {
            get() {
                return this.$store.state.dialog;
            },

            set(val) {
                this.setDialog(val);
            },
        },

        deleteDialog: {
            get() {
                return this.$store.state.deleteDialog;
            },

            set(val) {
                this.setDeleteDialog(val);
            },
        },

        productTag: {
            get() {
                return this.$store.state.loyaltyPanel.productsTags.productTag;
            },

            set(val) {
                this.setItem(val);
            },
        },

        query() {
            let query = "?";

            for (let key in this.$route.query) {
                query += `${key}=${this.$route.query[key]}&`;
            }

            return query.slice(0, query.length - 1);
        },
    },

    methods: {
        ...mapMutations([
            "setDialog",
            "setDeleteDialog",
            "setResetSuccess",
            "setResetValidation",
        ]),
        ...mapMutations("loyaltyPanel/productsTags", ["setItem"]),
        ...mapActions(["getPermission"]),
        ...mapActions("loyaltyPanel/productsTags", ["getItems", "remove"]),

        open(mode, item) {
            this.mode = mode;
            this.productTag = item;
            setTimeout(() => this.setResetSuccess(true), 300);
            this.setResetValidation(true);
            this.dialog = true;
        },
    },

    watch: {
        $route(val) {
            if (!val.query.page) {
                this.$router.replace({
                    query: {
                        page: 1,
                        ...this.$route.query,
                    },
                });
            }
            this.getItems(this.query);
        },

        page(page) {
            this.$router.replace({ query: { ...this.$route.query, page } });
        },
    },

    beforeCreate() {
        if (!this.$route.query.page) {
            this.$router.replace({
                query: {
                    page: 1,
                    ...this.$route.query,
                },
            });
        }
    },

    mounted() {
        this.getItems(this.query);
    },
};
</script>